import React from 'react';
import { getAdditionalPage } from '../../../services';
import AdditionalPage from '@/containers/AdditionalPage';
import Layout from '@/components/Layout';
import { checkForWrongDomain } from '@/utils/checkForWrongDomain';
import { getSSRStoreData } from '../../../utils/ssrPageData';
import { useSetSSRStore, useSSRSelector } from '../../../redux';

const AdditionalPageContainer = (props) => {
  useSetSSRStore(props.ssrStore);
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);
  const advCustomSeo = props.advCustomSeoDetails;

  return (
    <Layout
      store={storeInfo}
      title={
        advCustomSeo?.title?.value ||
        `${props?._addPage?.page_name} - ${storeInfo?.store_info?.name}`
      }
      Icon={storeInfo?.store_info?.logo_image}
      metaDescription={
        advCustomSeo?.description ||
        'Now order online from my whatsapp store & pay using 150+ UPI Apps'
      }
      OGTitle={advCustomSeo?.og_title?.value || null}
      OGDescription={advCustomSeo?.og_description || null}
      OGImage={storeInfo?.store_info?.logo_image}
      isCustomDomain={props.isCustomDomain}
      {...props}
    >
      <AdditionalPage {...props} />
    </Layout>
  );
};

export async function getServerSideProps(ctx) {
  const userAgent = ctx?.req?.headers?.['user-agent'];
  if (checkForWrongDomain(ctx)) return {};
  const { slug, template_id, preview } = ctx.query;
  let propData = {
    catalogCategories: [],
    catalogTags: [],
    _addPage: null,
    collections: [],
  };

  const propType = await getSSRStoreData(ctx, {
    additionalDataToFetch: [
      'collections',
      'categories',
      'advancedSeo',
      'additionalPagesList',
    ],
    advancedSeoReqConfigs: {
      type: 'additional_page',
      typeId: propData?._addPage?.page_id,
    },
  });

  if (propType?.ssrStore?.storeReducer?.store?.store_id) {
    const _addpageResponse = await getAdditionalPage(
      slug,
      propType.ssrStore.storeReducer.store.store_id,
      Boolean(Number(preview)),
      template_id
    );

    if (_addpageResponse.data && _addpageResponse.data.status) {
      propData._addPage = JSON.parse(JSON.stringify(_addpageResponse.data.page)) || null;
    } else {
      ctx.res.writeHead(302, { location: '/404' });
      ctx.res.end();
    }
  }

  propData = { ...propData, ...(propType || {}) };

  return { props: { ...propData, userAgent } };
}
export default AdditionalPageContainer;
